import { DropdownSection } from '@leagueplatform/web-common-components';
import { BoxProps } from '@leagueplatform/genesis-commons';
import {
  APP_MANAGED_ROUTES,
  injectCobrowseInitiator,
  UserDropdownProps,
} from '@highmark-web/highmark-common';
import { useIntl } from '@leagueplatform/locales';

export const useGetUserDropdownConfig = (props: UserDropdownProps) => {
  const { formatMessage } = useIntl();

  const userDropdownConfig: DropdownSection[] = [
    [
      {
        text: formatMessage({ id: 'ACCOUNT_MANAGEMENT' }),
        to: APP_MANAGED_ROUTES.ACCOUNT_MANAGEMENT,
      },
      // Conditionally add COB Link to list if insuranceAdministeredByThirdParty is true
      ...(props?.insuranceAdministeredByThirdParty
        ? [
            {
              text: formatMessage({ id: 'COORDINATION_OF_BENEFITS' }),
              to: APP_MANAGED_ROUTES.COORDINATION_OF_BENEFITS,
            },
          ]
        : []),
      {
        text: formatMessage({ id: 'START_COBROWSE' }),
        description: formatMessage({ id: 'START_COBROWSE_DESCRIPTION' }),
        to: '',
        onClick: () => {
          injectCobrowseInitiator();
        },
      },
    ],
    [
      {
        text: formatMessage({ id: 'ABOUT_BCBSWY' }),
        to: 'https://www.bcbswy.com/company_info/',
        target: '_blank',
      },
    ],
    [
      {
        to: '',
        text: formatMessage({ id: 'LOG_OUT' }),
        linkProps: {
          color: 'onSurface.text.critical',
        } as BoxProps,
        onClick: () => {
          props.onOpenSignoutModal();
        },
      },
    ],
  ];

  return userDropdownConfig;
};
